var render = function render(){var _vm=this,_c=_vm._self._c;return _c('audio',{ref:"audioPlayer",style:(_vm.fstyle),attrs:{"loop":_vm.loop,"src":_vm.fvalue,"muted":_vm.muted,"width":_vm.fwidth,"height":_vm.fheight,"controls":_vm.controls,"autoplay":_vm.autoplay},on:{"play":_vm.playAudio,"ended":_vm.handleEnd,"pause":_vm.pauseAudio,"timeupdate":_vm.handleTimeUpdate,"loadedmetadata":_vm.handleLoadedMetaData}})
}
var staticRenderFns = []

export { render, staticRenderFns }